"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopCardFieldWarningsDescriptions = exports.StopCardFieldWarningsLabels = exports.StopCardFieldDescriptions = exports.StopCardFieldLabels = exports.StopCardFieldWarning = exports.StopCardField = exports.StopCardFieldWarnings = exports.StopCardFields = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.StopCardFields = [
    'order.material',
    'order.dumpsterSize',
    'order.boxNumber',
    'order.orderNumber',
    'order.customerDisplayName',
    'order.rentalEndDate',
    'order.poNumber',
    'driverNotes',
    // Always Defaulted on fields
    'taskType',
    'address',
    'disposalFacility',
];
exports.StopCardFieldWarnings = ['displayOutStandingBalances', 'showSeviceAgreementNotSigned'];
exports.StopCardField = typebox_1.Type.Union(exports.StopCardFields.map((m) => typebox_1.Type.Literal(m)));
exports.StopCardFieldWarning = typebox_1.Type.Union(exports.StopCardFieldWarnings.map((m) => typebox_1.Type.Literal(m)));
exports.StopCardFieldLabels = {
    'order.material': 'Material',
    'order.dumpsterSize': 'Dumpster Size',
    'order.boxNumber': 'Box Number',
    'order.orderNumber': 'Order Number',
    'order.customerDisplayName': 'Customer Display Name',
    'order.rentalEndDate': 'Rental End Date',
    'order.poNumber': 'PO Number',
    driverNotes: 'Driver Notes',
    // Always Defaulted on fields
    taskType: 'Task Type',
    address: 'Address',
    disposalFacility: 'Disposal Facility',
};
exports.StopCardFieldDescriptions = {
    'order.customerDisplayName': 'Displays the company name, or the primary contact if no company name is set',
    'order.material': '',
    'order.dumpsterSize': '',
    'order.boxNumber': '',
    'order.orderNumber': '',
    'order.rentalEndDate': '',
    'order.poNumber': '',
    driverNotes: 'Displays notes marked "visible to drivers" (set in Tasks & Notes)',
    // Always Defaulted on fields
    taskType: 'Delivery, Pickup, Swap',
    address: '',
    disposalFacility: 'Only displayed on Pickup tasks',
};
exports.StopCardFieldWarningsLabels = {
    displayOutStandingBalances: 'Invoice past due',
    showSeviceAgreementNotSigned: 'Show service agreement not signed',
};
exports.StopCardFieldWarningsDescriptions = {
    displayOutStandingBalances: 'Flag for when an order is unpaid and overdue',
    showSeviceAgreementNotSigned: "Flag for when a customer's agreement is pending signature",
};
//# sourceMappingURL=stop-card-fields.js.map